import { render, staticRenderFns } from "./GridContingencia.vue?vue&type=template&id=a12e6d6a&"
import script from "./GridContingencia.vue?vue&type=script&lang=js&"
export * from "./GridContingencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports